// https://blog.capsens.eu/how-to-write-javascript-in-rails-6-webpacker-yarn-and-sprockets-cdf990387463
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import 'css/site'
import 'css/messages'
import 'css/layout'
import 'css/bootstrap_configuration'
import 'css/bootstrap_extensions'
import 'css/calendar'
import 'css/scaffolds'
import 'css/invoices'
import 'css/functions/fun3'
import 'css/functions/fun10'
import 'css/functions/fun12'
import 'css/functions/functions'
import 'css/select2_ext'
import 'css/tepdocs'
import 'css/kiosks'
import 'css/tep'

import 'jquery'
import 'popper.js'
import 'bootstrap'
import 'moment'
import 'bootstrap-datepicker'
import "bootstrap-datepicker/dist/css/bootstrap-datepicker3.standalone.css"
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js"
import 'select2'
import 'select2/dist/css/select2.css'
import 'ekko-lightbox'
import 'ekko-lightbox/dist/ekko-lightbox.css'

import 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import "@fortawesome/fontawesome-free/css/all"
import 'bootstrap-notify'
import printJS from 'print-js'

import "packs/custom_js/runtime.js"
import "packs/custom_js/tepdoc.js"
import "packs/custom_js/global_var.js"
import "packs/custom_js/kiosk.js"
import "packs/custom_js/functions/shared/shared.js"
import "packs/custom_js/functions/menu_1_2_4_5_6_7/req.js"
import "packs/custom_js/functions/menu8/req1.js"
import "packs/custom_js/functions/menu8/req4.js"
import "packs/custom_js/functions/menu3/req_x.js"
import "packs/custom_js/functions/menu11/req3.js"
import "packs/custom_js/functions/menu10/req1.js"


Rails.start()
Turbolinks.start()
ActiveStorage.start()

//fodamentale per le modali
window.$ = window.jQuery = require('jquery');